;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/:locale/:slug*?\",\"regex\":\"^/([^/]+)(?:/(.*))?$\",\"paramNames\":[\"locale\",\"slug\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/ea-bot/:slug*?\",\"regex\":\"^/([^/]+)/ea-bot(?:/(.*))?$\",\"paramNames\":[\"locale\",\"slug\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/ea-query/:page\",\"regex\":\"^/([^/]+)/ea-query/([^/]+)$\",\"paramNames\":[\"locale\",\"page\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/ea-redirect/:slug*?\",\"regex\":\"^/([^/]+)/ea-redirect(?:/(.*))?$\",\"paramNames\":[\"locale\",\"slug\"],\"hasOptionalPrefix\":true},{\"path\":\"/ea-maintenance-bypass/:locale/:slug*?\",\"regex\":\"^/ea-maintenance-bypass/([^/]+)(?:/(.*))?$\",\"paramNames\":[\"locale\",\"slug\"],\"hasOptionalPrefix\":true}],\"staticRoutes\":[],\"isrRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.4.2";import { shouldDropSentryClientEvent } from '@eliadmin/core/src/sentry/client-event-filter';
import * as Sentry from '@sentry/nextjs';

const CHUNK_RELOAD_KEY = 'eli:chunk-load-reload-at';
const CHUNK_RELOAD_COOLDOWN_MS = 30_000;

function getErrorMessage(error: unknown) {
  if (!error) return '';
  if (typeof error === 'string') return error;
  if (error instanceof Error) return `${error.name}: ${error.message}`;
  if (typeof error === 'object' && 'message' in error) {
    return String((error as { message?: unknown }).message ?? '');
  }
  return String(error);
}

function isChunkLoadError(error: unknown) {
  const message = getErrorMessage(error);

  return (
    /ChunkLoadError/i.test(message) ||
    /Failed to load chunk/i.test(message) ||
    /Loading chunk .* failed/i.test(message) ||
    /failed to fetch dynamically imported module/i.test(message) ||
    /Importing a module script failed/i.test(message)
  );
}

function reloadOnceForChunkLoadError(error: unknown) {
  if (typeof window === 'undefined' || !isChunkLoadError(error)) return;

  Sentry.captureException(error);

  const lastReloadAt = Number(window.sessionStorage.getItem(CHUNK_RELOAD_KEY) ?? 0);
  if (Date.now() - lastReloadAt < CHUNK_RELOAD_COOLDOWN_MS) return;

  window.sessionStorage.setItem(CHUNK_RELOAD_KEY, String(Date.now()));
  window.location.reload();
}

Sentry.init({
  dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
  tracesSampleRate: 0,
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 0,
  debug: false,
  beforeSend(event, hint) {
    if (shouldDropSentryClientEvent(event, hint)) return null;
    return event;
  },
});

if (typeof window !== 'undefined') {
  window.addEventListener('error', event => {
    reloadOnceForChunkLoadError(event.error ?? event.message);
  });

  window.addEventListener('unhandledrejection', event => {
    reloadOnceForChunkLoadError(event.reason);
  });
}

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
